import { create } from "zustand";
import type { Number } from "@/services/numberApi";

interface NumberUIState {
  searchTerm: string;
  sourceFilter: string;
  companyFilter: string;
  isFormOpen: boolean;
  selectedNumber: Number | null;
  formLoading: boolean;
  setSearchTerm: (value: string) => void;
  setSourceFilter: (value: string) => void;
  setCompanyFilter: (value: string) => void;
  openCreateForm: () => void;
  openEditForm: (number: Number) => void;
  closeForm: () => void;
  setFormLoading: (value: boolean) => void;
}

export const useNumberUIStore = create<NumberUIState>((set) => ({
  searchTerm: "",
  sourceFilter: "all",
  companyFilter: "all",
  isFormOpen: false,
  selectedNumber: null,
  formLoading: false,
  setSearchTerm: (value) => set({ searchTerm: value }),
  setSourceFilter: (value) => set({ sourceFilter: value }),
  setCompanyFilter: (value) => set({ companyFilter: value }),
  openCreateForm: () => set({ isFormOpen: true, selectedNumber: null }),
  openEditForm: (number) => set({ isFormOpen: true, selectedNumber: number }),
  closeForm: () => set({ isFormOpen: false, selectedNumber: null }),
  setFormLoading: (value) => set({ formLoading: value }),
}));
